import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { PassportLogo } from "@/components/Reveal";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import { useTranslation } from "react-i18next";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
    const nav = useNavigate();
    const { applyGoogleSession } = useAuth();
    const { t } = useTranslation();
    const processed = useRef(false);

    useEffect(() => {
        if (processed.current) return;
        processed.current = true;
        const hash = window.location.hash || "";
        const m = hash.match(/session_id=([^&]+)/);
        if (!m) {
            nav("/auth");
            return;
        }
        const session_id = decodeURIComponent(m[1]);
        applyGoogleSession(session_id)
            .then(() => {
                // clean the hash
                window.history.replaceState({}, "", "/app");
                toast.success(t("authCallback.welcome"));
                nav("/app", { replace: true });
            })
            .catch(() => {
                toast.error(t("authCallback.failed"));
                nav("/auth", { replace: true });
            });
    }, [applyGoogleSession, nav]);

    return (
        <div className="min-h-screen grid place-items-center grain">
            <motion.div initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} className="text-center">
                <div className="w-16 h-16 mx-auto mb-6 rounded-2xl grid place-items-center animate-pulse"
                    style={{ background: "rgba(212,175,55,0.08)", border: "1px solid rgba(212,175,55,0.3)" }}>
                    <PassportLogo size={40} />
                </div>
                <div className="overline">{t("authCallback.issuing")}</div>
            </motion.div>
        </div>
    );
}
